export const contentWidth = 980



// WEBPACK FOOTER //
// ./src/dims.js